import React, { useEffect, useState } from "react";
import RouteManager from "../../managers/RouteManager";
import { DKLabel, DKButton, DKLine, DKTooltipWrapper, DKCheckMark, DKIcon, DKInput, INPUT_VIEW_DIRECTION, DKSpinner, removeLoader, showLoader, showToast, TOAST_TYPE } from "deskera-ui-library"
import { CONFIGURE_COMP_OFF_FIELDS } from "./CompOffConstants";
import { CONSTANTS, INPUT_TYPE } from "../../constants/Constant";
import ic_info_message from "../../assets/icons/ic_info_gray01.png";
import Utility, { deepClone } from "../../utility/Utility";
import { CompoffService } from "../../services/CompOffService";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import EmployeeListService from "../../services/EmployeeListService";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompOffSettings, selectConfigurationSettings } from "../../Redux/Slices/CompOffSlice";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";



const ConfigureCompOff = (props) => {

    const history = useHistory();
    const { t } = useTranslation();

    /**Hooks */
    const [configureFieldConfig, setFieldConfig] = useState(CONFIGURE_COMP_OFF_FIELDS)
    const [formValues, setFormValues] = useState({
        expiryDuration:{id:"NA", name:"N.A"}
    });
    const [isProcessing, setProcessining] = useState(true);


    /**Selectors */
    const configDetails = useSelector(selectConfigurationSettings);

    /**Dispatch */
    const dispatch = useDispatch()


    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        setProcessining(true);
        loadConfigurationSettings()
    }, []);

    useEffect(() => {
        if(!Utility.isEmptyObject(configDetails)) {
            // setProcessining(true);
            setConfigurationData();
            setProcessining(false);
        }
    },[configDetails]);

    const loadConfigurationSettings = async () => {
        try{
            await dispatch(fetchCompOffSettings());
        }catch(err) {
            setProcessining(false);
        }
    }

    const navigateTo = () => {
        RouteManager.navigateToHome()
    }

    const setConfigurationData = () => {
        let values = deepClone(formValues);
        for(const k in configDetails) {
            values[k] = configDetails[k];
        } 
        configureFieldConfig.forEach((c) => {
            switch (c.type) {
                case INPUT_TYPE.DROPDOWN:
                    values[c.columnCode] = EmployeeListService.getValueObjectFromDropdown(configDetails[c.columnCode], c.options, "id");
                    break;
            
                default:
                    values[c.columnCode] = configDetails[c.columnCode]
                    break;
            }
        })
        setFormValues(values)
    }

    const saveSettings = () => {
        const { invalid, params } = checkValidation();
        if (invalid) {
            return;
        }
        if(Utility.isEmpty(formValues['id'])) {
            showLoader(t("COMP_OFF_SAVE_IN_PROGRESS"))
            CompoffService.postConfigurationSettings(params).then((response) => {
                showToast(t("COMP_OFF_SAVED_SUCCESS"), TOAST_TYPE.SUCCESS);
                // navigateTo();
                removeLoader();
            }, (err) => {
                showToast(t("SOMETHING_WENT_WRONG"), TOAST_TYPE.ERROR);
                removeLoader();
            })
        } else {
            params['id'] = formValues['id'];
            showLoader(t("COMP_OFF_UPDATE_IN_PROGRESS"))
            CompoffService.updateConfigurationSettings(params).then((response) => {
                showToast(t("COMP_OFF_UPDATE_SUCCESS"), TOAST_TYPE.SUCCESS);
                // navigateTo();
                removeLoader();
            }, (err) => {
                showToast(t("SOMETHING_WENT_WRONG"), TOAST_TYPE.ERROR);
                removeLoader();
            })
        }
    }

    const checkValidation = () => {
        let config = deepClone(configureFieldConfig);
        const params = {};
        const alteredConfig = [];
        const invalidFields = [];
        for (let c = 0; c < config.length; c++) {
            let { invalid, errMsg } = isInvalid(config[c].validation, formValues[config[c].columnCode]);
            if (invalid) {
                invalidFields.push(config[c].columnCode)
                alteredConfig.push({ columnCode: config[c].columnCode, hasError: invalid, errMsg: errMsg })
            } else {
                alteredConfig.push({ columnCode: config[c].columnCode, hasError: invalid, errMsg: errMsg })
                params[config[c].columnCode] = EmployeeListService.getSelectedIdFromObject(formValues[config[c].columnCode], "id");
            }
            switch (config[c].type) {
                case INPUT_TYPE.DROPDOWN:
                    params[config[c].columnCode] = EmployeeListService.getSelectedIdFromObject(formValues[config[c].columnCode], "id");
                    break;

                default:
                    params[config[c].columnCode] = formValues[config[c].columnCode]
                    break;
            }
        }
        const invalid = invalidFields.length > 0;
        EmployeeListService.getAlteredConfigDetails(config, alteredConfig, false, {}, {});
        setFieldConfig(config);
        return { params, invalid}
    }

    const isInvalid = (validation, value) => {
        let invalid = false;
        let errMsg = CONSTANTS.EMPTY_STRING;
        if(!Utility.isEmpty(validation)) {
            for (let v = 0; v < validation.length; v++) {
                switch (validation[v]) {
                    case "required":
                        if (Utility.isEmptyObject(value)) {
                            invalid = true;
                            errMsg = "Enter a valid value"
                        }
                        break;
    
                    default:
                        break;
                }
            }
        }
        return { invalid, errMsg }
    }

    const getFieldRequired = (field) => {
        const validator = field.validation;
        let isRequired = false;
        if (validator && validator.some(x => x === "required")) isRequired = true;
        return isRequired;

    }

    const onCheckBoxClick = (c) => {
        const config = deepClone(configureFieldConfig);
        switch (c.columnCode) {
            case "value":

                break;

            default:
                formValues[c.columnCode] = !formValues[c.columnCode];
                break;
        }

        setFieldConfig(config);
    }

    const onChange = (v, c) => {
        const config = deepClone(configureFieldConfig);
        const alteredConfig = [];
        switch (c.columnCode) {
            case "":

                break;

            default:
                formValues[c.columnCode] = v;
                let { invalid, errMsg } = isInvalid(c.validation, formValues[c.columnCode]);
                if (invalid) {
                    alteredConfig.push({ columnCode: c.columnCode, hasError: invalid, errMsg: errMsg })
                } else {
                    alteredConfig.push({ columnCode: c.columnCode, hasError: invalid, errMsg: errMsg })
                }                
                break;
        }
        EmployeeListService.getAlteredConfigDetails(config, alteredConfig, false, {}, {});
        setFieldConfig(config);
    }

    const getFormSection = () => {
        const isReadOnly = !PermissionUtils.hasAccess(MODULE.COMP_OFF_CONFIGURATION,[ACTION.EDIT, ACTION.CREATE])
        return (
            configureFieldConfig.map((c) => {
                return (
                    <>
                        {c.type === INPUT_TYPE.CHECKBOX && (
                            <div
                                className="row p-h-l p-v-l"
                                style={{
                                    width: "50%",
                                    pointerEvents: `${isReadOnly ? "none" : ""
                                        }`,

                                }}
                                key={c.columnCode}
                            >
                                <div
                                    onClick={() => onCheckBoxClick(c)}
                                    style={{
                                        cursor: `${isReadOnly ? "none" : "pointer"}`
                                    }}
                                >
                                    <DKCheckMark
                                        isSelected={
                                            formValues[c.columnCode]
                                        }
                                        color={isReadOnly ? "bg-gray":"bg-app"}
                                        disabled={isReadOnly}
                                    />
                                </div>
                                <DKLabel className="ml-s" text={c.name} />
                                {c.hasTooltip && c.tooltipText != "" && (
                                    <DKTooltipWrapper
                                        content={c.tooltipText}
                                        tooltipClassName="warning-tooltip-prop "
                                    >
                                        <DKIcon
                                            src={ic_info_message}
                                            className="ml-s ic-s ml-r mt-xs cursor-hand "
                                            style={{ opacity: 0.4 }}
                                        />
                                    </DKTooltipWrapper>
                                )}
                            </div>
                        )}
                        {c.type === INPUT_TYPE.DROPDOWN && (
                            <div
                                className="column p-h-l web-width-50 mb-s padding-bottom-mobile"
                                key={c.columnCode}
                            >
                                <DKInput
                                    title={c.name}
                                    placeholder={c.name}
                                    value={formValues[c.columnCode]}
                                    className=''
                                    formatter={(obj) => {
                                        /** How to render a selected option in case of object **/
                                        return obj.name;
                                    }}
                                    displayKey={"name"}
                                    options={c.options}
                                    type={c.type}
                                    labelClassName=" text-align-left "
                                    onChange={(v) => {
                                        onChange(v, c);
                                    }}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    required={getFieldRequired(c)}
                                    readOnly={c.readOnly}
                                    onClick={() => { }}
                                    dropdownConfig={{
                                        className: "",
                                        style: {},
                                        allowSearch: c.options && c.options.length > 6 ? true : false,
                                        searchableKey: "name",
                                        data: c.options,
                                        renderer: (index, obj) => {
                                            /*How to render dropdwon options from array of object*/
                                            return <DKLabel className="" text={obj.name} />;
                                        },
                                        onSelect: (index, value) => { },
                                    }}
                                    canValidate={c.hasError}
                                    validator={(value) => {
                                        return !c.hasError;
                                    }}
                                    errorMessage={c.errMsg}
                                />
                            </div>
                        )}

                    </>
                )
            })
        )
    }

    const getHeader = () => {
        return (
            <div className="parent-width d-flex justify-content-between mb-l">
                <DKLabel
                    text="Configure Compensatory Off"
                    className=" fs-r text-align-left fw-m fs-l"
                />
                <div className="d-flex">
                    <DKButton
                        title="Cancel"
                        className="border-radius-m bg-gray1 border-m mr-m"
                        onClick={() => {
                            navigateTo()
                        }}
                    />
                    {PermissionUtils.hasAccess(MODULE.COMP_OFF_CONFIGURATION,[ACTION.EDIT, ACTION.CREATE]) && <DKButton
                        title="Save"
                        className="bg-app text-white"
                        onClick={() => {
                            saveSettings()
                        }}
                    />}
                </div>
            </div>
        )
    }

    return (
        <>
            {getHeader()}
            <div className=" parent-width bg-white border-radius-s card-shadow">
                <div className="d-flex flex-wrap">
                    <div className="row">
                        <DKLabel text="Compensatory Off Settings" className="p-l fw-m fs-m" />
                        {isProcessing && <DKSpinner />}
                    </div>
                    <DKLine className="bg-gray3 mb-s" />
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                        }}
                        className=" parent-width parent-width mb-s  pb-m pt-s"
                    >
                        {getFormSection()}
                    </div>

                </div>

            </div>
        </>
    )
}

export default ConfigureCompOff;